
import { UseFormReturn } from 'react-hook-form';
import { RegisterFormData } from '../schemas/registerFormSchema';
import {
  FormField,
  FormItem,
  FormControl,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';
import { useTranslation } from 'react-i18next';

interface TermsAgreementProps {
  form: UseFormReturn<RegisterFormData>;
}

export function TermsAgreement({ form }: TermsAgreementProps) {
  const { t } = useTranslation();

  return (
    <FormField
      control={form.control}
      name='terms'
      render={({ field }) => (
        <FormItem className='flex flex-row items-start space-x-3 space-y-0 p-1'>
          <FormControl>
            <Checkbox 
              checked={field.value} 
              onCheckedChange={field.onChange} 
            />
          </FormControl>
          <div className='space-y-1 leading-none'>
            <FormLabel className='text-sm font-normal'>
              {t('termsAgreement.agreeTo')}{' '}
              <a href='#' className='text-primary hover:underline'>
                {t('termsAgreement.termsOfService')}
              </a>{' '}
              {t('termsAgreement.and')}{' '}
              <a href='#' className='text-primary hover:underline'>
                {t('termsAgreement.privacyPolicy')}
              </a>
            </FormLabel>
            <FormMessage />
          </div>
        </FormItem>
      )}
    />
  );
}
